/**
 * 请求成功状态码（后端响应壳约定：HTTP 200 + code=200 表示业务成功）
 */
export const SUCCESS_CODE = 200

/**
 * 请求contentType
 */
export const CONTENT_TYPE = 'application/json'

/**
 * 请求超时时间
 */
export const REQUEST_TIMEOUT = 60000

/**
 * JWT Authorization 头前缀
 */
export const TOKEN_PREFIX = 'Bearer '

/**
 * 不需要附 Authorization 头的请求路径（相对 baseURL 的 URL 片段）
 */
export const NO_AUTH_WHITE_LIST = ['/auth/login', '/health']

/**
 * 不重定向白名单
 */
export const NO_REDIRECT_WHITE_LIST = ['/login']

/**
 * 不重置路由白名单（登出后不删除这些路由，否则再登录会找不到静态路由）
 */
export const NO_RESET_WHITE_LIST = [
  'Redirect',
  'RedirectWrap',
  'Login',
  'NoFind',
  'Fallback',
  'Root',
  // Dashboard 静态路由（见 router/index.ts）：登出后必须保留，否则再登录会跳 404
  'Dashboard',
  'DashboardAnalysis',
  // 系统管理静态路由
  'System',
  'SystemUsers',
  'SystemRoles',
  'SystemPermissions',
  // 教学管理静态路由
  'Teaching',
  'TeachingCourses',
  'TeachingSkills',
  'TeachingAssets',
  // 答疑管理静态路由
  'Qa',
  'QaRecords'
]

/**
 * 内置权限码（与 fang-cloud 后端 flj_permission 表的 UK code 对齐）
 */
export const PERMISSION_CODES = {
  USER_READ: 'user.read',
  USER_EDIT: 'user.edit',
  USER_MANAGE: 'user.manage',
  PERMISSION_READ: 'permission.read',
  PERMISSION_EDIT: 'permission.edit',
  PERMISSION_MANAGE: 'permission.manage',
  ROLE_READ: 'role.read',
  ROLE_EDIT: 'role.edit',
  ROLE_MANAGE: 'role.manage',
  COURSE_READ: 'course.read',
  COURSE_EDIT: 'course.edit',
  COURSE_MANAGE: 'course.manage',
  SKILL_READ: 'skill.read',
  SKILL_EDIT: 'skill.edit',
  SKILL_MANAGE: 'skill.manage',
  ASSET_READ: 'asset.read',
  ASSET_EDIT: 'asset.edit',
  ASSET_MANAGE: 'asset.manage',
  ASSET_DOWNLOAD: 'asset.download',
  QA_READ: 'qa.read'
} as const

export type PermissionCode = (typeof PERMISSION_CODES)[keyof typeof PERMISSION_CODES]
